import { isBlank } from './detailShared'
// ADDENDUM 52 (lienzo, «Avance · desplegable») — las columnas de la tabla de reportes de una
// operación: UNA POR TIPO DE CALIDAD.
//
// ⚠️⚠️ LOS TIPOS SE DERIVAN DE LO QUE LLEGA, NUNCA SE CABLEAN. Hoy la base tiene tres —Ok (80),
// Burr (4), Out of tolerance (3)— y es tentador escribir esas tres columnas. El catálogo puede
// crecer: una lista fija dejaría fuera al cuarto tipo SIN QUE NADIE LO NOTE, porque la tabla
// seguiría pintándose perfecta y solo faltaría una columna que nadie echa de menos.
//
// 📌 Y NO SE CLASIFICAN EN «BUENAS» Y «RECHAZADAS» (S288). El catálogo de `QualityType` no lleva
// esa clasificación —lo dice el javadoc del lector de Sun: "no good/reject classification"—, así
// que repartirlas en dos columnas exigiría inventar a qué lado va cada tipo. `Burr` no es
// obviamente una ni otra, y decidirlo aquí sería decidir por el taller.
//
// ⚠️ NO HAY COLUMNA DE TIEMPO, y no es un olvido: "time is a fact of the operation, never of a
// report" (S173/R-15/D27). El lector de Sun ni siquiera sirve el campo, y hay un test suyo que lo
// hace cumplir. El tiempo vive en la tarjeta de la cabecera del despliegue.

/**
 * Los tipos de calidad presentes en estos reportes, EN ORDEN DE PRIMERA APARICIÓN.
 *
 * El orden se hereda de cómo llegan los reportes (Sun los sirve cronológicos descendentes) en vez
 * de reordenarse alfabéticamente: un orden propio aquí sería una segunda definición del mismo
 * criterio, y es la que acaba divergiendo. Es la misma decisión que `OperationWorkersPolicy`.
 *
 * @param {Array} reports los reportes de UNA operación
 * @returns {Array<{id: *, name: string}>} vacío si no hay reportes o ninguno trae cantidades
 */
export const qualityTypeColumns = (reports) => {
  const quantities = []
  ;(reports || []).forEach((report) => {
    ;((report || {}).quantities || []).forEach((quantity) => {
      if (!isBlank(quantity.qualityTypeName)) quantities.push(quantity)
    })
  })
  // The same type can arrive with its id in one report and without it in another: the name of a
  // type that has an id somewhere joins the entries without id to that column.
  const idByName = new Map()
  quantities.forEach((quantity) => {
    if (!isBlank(quantity.qualityTypeId) && !idByName.has(quantity.qualityTypeName)) idByName.set(quantity.qualityTypeName, quantity.qualityTypeId)
  })
  const vistos = new Map()
  quantities.forEach((quantity) => {
    const clave = !isBlank(quantity.qualityTypeId)
      ? quantity.qualityTypeId
      : (idByName.has(quantity.qualityTypeName) ? idByName.get(quantity.qualityTypeName) : `name:${quantity.qualityTypeName}`)
    if (!vistos.has(clave)) vistos.set(clave, { id: clave, name: quantity.qualityTypeName })
  })
  return Array.from(vistos.values())
}

/**
 * Lo reportado de ese tipo en ese reporte, o `null` si ese reporte no lo trae.
 *
 * ⚠️ `null` NO ES CERO. Un reporte que no menciona «Burr» no está diciendo que hubo cero piezas con
 * rebaba: no dice nada de la rebaba. Quien pinta escribe un guion, no un 0 (RN8).
 */
export const quantityOfType = (report, column) => {
  const { id, name } = column !== null && typeof column === 'object' ? column : { id: column, name: undefined }
  const matching = (((report || {}).quantities) || []).filter((quantity) => {
    if (isBlank(quantity.quantity)) return false
    if (!isBlank(quantity.qualityTypeId)) return quantity.qualityTypeId === id
    return id === `name:${quantity.qualityTypeName}` || (name !== undefined && quantity.qualityTypeName === name)
  })
  // A report may repeat a type: the entries are summed, never just the first one kept.
  return matching.length === 0 ? null : matching.reduce((sum, quantity) => sum + Number(quantity.quantity), 0)
}
